import styled, { css } from 'styled-components';

import { InfoCircleOutline } from '~/components/shared/core/icons/InfoCircleOutline';

const S = {
  TooltipIconContainer: styled.button<{ $active?: boolean }>`
    ${({ theme }) => css`
      color: ${theme.colors.content.tertiary};
      width: ${theme.size[3]};
      height: ${theme.size[3]};
      margin: 0 ${theme.padding['3xs']} 0 0;
      display: flex;
      align-items: center;

      &:hover,
      &:focus {
        cursor: pointer;
      }
    `}
  `,
};

export const ProductPriceRrpTooltipToggler = ({
  onClick,
  tooltipOpened,
}: {
  onClick: () => void;
  tooltipOpened: boolean;
}) => (
  <S.TooltipIconContainer onClick={onClick} $active={tooltipOpened} data-testid="rrp-tooltip">
    <InfoCircleOutline color="currentColor" hoverColor="currentColor" />
  </S.TooltipIconContainer>
);
